// @flow

import 'rheostat/initialize';
import React from 'react';
import styled from 'styled-components';
import Rheostat from 'rheostat';
import type { Theme } from '../../../types';

type Props = {
  min: number,
  max: number,
  onValuesUpdated: (values: [number, number]) => void,
  values: [number, number],
};

const Wrapper = styled<any, Theme>('section')`
  width: 100%;

  .rheostat {
    position: relative;
    overflow: visible;
    height: 1.25rem;
    margin-bottom: 1rem;

    .DefaultProgressBar__vertical {
      width: 24px;
      height: 100%
    }

    .DefaultProgressBar_progressBar__vertical {
      height: 100%;
      width: 24px
    }

    .DefaultProgressBar_background__vertical {
      height: 100%;
      top: 0px;
      width: 15px
    }

    .DefaultProgressBar_background__horizontal {
      height: 13px;
      top: 0px
    }
    
    .DefaultHandle_handle {
      border-radius: 50%;
      width: 1.125rem;
      height: 1.125rem;
      box-sizing: border-box;
      background-color: ${props => props.theme.form.rangeSlider.handleBackground};
      border: solid 1px ${props => props.theme.form.rangeSlider.handleBorder};
      z-index: 2;
      outline: none;
      box-shadow: 0 2px 2px #dbdbdb
    }

    .DefaultHandle_handle:focus {
      box-shadow: #abc4e8 0 0 1px 1px
    }

    .DefaultHandle_handle__horizontal {
      top: -5px;

      &:last-child {
        margin-left: -12px;
      }
    }

    .DefaultHandle_handle__horizontal:before {
      top: 7px;
      height: 10px;
      width: 1px;
      left: 10px
    }

    .DefaultHandle_handle__horizontal:after {
      top: 7px;
      height: 10px;
      width: 1px;
      left: 13px
    }

    .DefaultHandle_handle__vertical {
      margin-top: -12px;
      left: -10px
    }

    .DefaultHandle_handle__vertical:before {
      top: 10px
    }

    .DefaultHandle_handle__vertical:after {
      top: 13px;
      left: 8px;
      height: 1px;
      width: 10px
    }

    .DefaultHandle_handle__disabled {
      border-color: #dbdbdb
    }

    .DefaultBackground_background__horizontal {
      height: 15px;
      top: -1px;
      left: -2px;
      bottom: 4px;
      width: 100%
    }

    .DefaultBackground_background__vertical {
      width: 15px;
      top: 0px;
      height: 100%
    }

    .DefaultProgressBar_progressBar {
      background-color: ${props => props.theme.form.rangeSlider.progressColor};
      height: 0.25rem;
      position: absolute;
      z-index: 0;
    }

    .DefaultBackground {
      border: 1px solid #d8d8d8;
      background-color: ${props => props.theme.form.rangeSlider.backgroundColor};
      border-radius: 4px;
      height: 0.25rem;
      position: absolute;
    }
  }

  @media (min-width: 1128px) {
    .autoAdjustVerticalPosition {
      top: 12px
    }
  }

  .rheostat__vertical {
    height: 100%
  }

  .handleContainer {
    height: 15px;
    top: -2px;
    left: -2px;
    bottom: 4px;
    width: 100%;
    position: absolute
  }

  .rheostat_background {
    background-color: #fcfcfc;
    border: 1px solid #d8d8d8;
    position: relative
  }

  .rheostat_background__horizontal {
    height: 15px;
    top: -2px;
    left: -2px;
    bottom: 4px;
    width: 100%
  }

  .rheostat_background__vertical {
    width: 15px;
    top: 0px;
    height: 100%
  } 
`;

const RangeSlider = (props: Props) => (
  <Wrapper>
    <Rheostat {...props} />
  </Wrapper>
);

export default RangeSlider;
